import { render, staticRenderFns } from "./TransferDetailInformation.vue?vue&type=template&id=28b28b76&"
import script from "./TransferDetailInformation.vue?vue&type=script&lang=js&"
export * from "./TransferDetailInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports